<template lang="pug">
//- Copies `text` to the clipboard; shows `copiedLabel` for 1.6s. Falls back to a prompt when the clipboard API is blocked.
button.copy-btn(type="button", @click="copy") {{ copied ? copiedLabel : label }}
</template>

<script>
export default {
  name: 'CopyButton',
  props: {
    text: { type: String, required: true },
    label: { type: String, required: true },
    copiedLabel: { type: String, required: true },
    fallbackLabel: { type: String, default: 'Copy manually:' },
  },
  data() { return { copied: false } },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.text)
        this.copied = true
        setTimeout(() => { this.copied = false }, 1600)
      } catch (e) {
        window.prompt(this.fallbackLabel, this.text)
      }
    },
  },
}
</script>
